import {
    ADMINGETMAPPINGBANK_SUCCESS,
    ADMINGETMAPPINGBANK_FAILED,
    RESET_ADMINGETMAPPINGBANK,
    LOADING_ADMINGETMAPPINGBANK,
    NETWORK_ERROR_ADMINGETMAPPINGBANK
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAdminMappingBank = () => {
    return { type: RESET_ADMINGETMAPPINGBANK };
};

const getMappingBankAdmin = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMINGETMAPPINGBANK });
    await adminServices
        .post("getMappingBank", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminGetMappingBanksuccess(res.data));
                    break;
                default:
                    dispatch(adminGetMappingBankFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMINGETMAPPINGBANK,
                payload: err
            });
        });
};


function adminGetMappingBanksuccess(data) {
    return {
        type: ADMINGETMAPPINGBANK_SUCCESS,
        payload: data
    };
}
function adminGetMappingBankFailed(data) {
    return {
        type: ADMINGETMAPPINGBANK_FAILED,
        payload: data
    };
}

export { getMappingBankAdmin, resetAdminMappingBank }